/**
 * 取消预约：展示某 memberProject 下的安排列表，按行取消（WrappedModal 的 baseComponent）
 */
import React from 'react'
import PropTypes from 'prop-types'
import { Form, Table, Spin, Empty, Button, Popconfirm, Tag, message } from 'antd'
import dayjs from 'dayjs'
import { getMemberProjectPlans } from '@/service/dispatchPage'
import { cancelSingleProjectAppointmentThunk } from '@/redux/order/dispatchPageSlice'
import { renderTextStr, formatDayString } from '@/utils/renderUtils'

class CancelMemberProjectPlansForm extends React.Component {
  static propTypes = {
    form: PropTypes.object,
    memberProjectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    dispatch: PropTypes.func.isRequired,
    onSuccess: PropTypes.func
  }

  state = {
    loading: false,
    list: []
  }

  componentDidMount() {
    this.fetchPlans()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.memberProjectId !== this.props.memberProjectId) {
      this.fetchPlans()
    }
  }

  fetchPlans = async () => {
    const { memberProjectId } = this.props
    if (memberProjectId == null || memberProjectId === '') {
      this.setState({ list: [] })
      return
    }
    this.setState({ loading: true })
    try {
      const res = await getMemberProjectPlans(memberProjectId)
      const raw = res && res.data
      const list = Array.isArray(raw) ? raw : []
      this.setState({ list })
    } catch (e) {
      const errText = typeof e === 'string' ? e : (e && (e.msg || e.message)) || '加载预约列表失败'
      message.error(errText)
      this.setState({ list: [] })
    } finally {
      this.setState({ loading: false })
    }
  }

  formatTimeRange = (start, end) => {
    if (start == null && end == null) return '-'
    const fmt = (t) => {
      if (t == null || t === '') return ''
      const d = typeof t === 'number' && String(t).length <= 10 ? dayjs.unix(t) : dayjs(t)
      return d.isValid() ? d.format('HH:mm') : ''
    }
    const a = fmt(start)
    const b = fmt(end)
    if (!a && !b) return '-'
    return `${a || '-'} ~ ${b || '-'}`
  }

  handleCancelOne = async (plan) => {
    const { dispatch, onSuccess } = this.props
    if (!plan || plan.isExecute) return
    try {
      await dispatch(cancelSingleProjectAppointmentThunk({ id: plan.id })).unwrap()
      message.success('已取消预约')
      await this.fetchPlans()
      if (typeof onSuccess === 'function') onSuccess()
    } catch (err) {
      message.error(err && err.message ? err.message : err || '取消失败')
    }
  }

  render() {
    const { form } = this.props
    const { loading, list } = this.state

    const columns = [
      {
        title: '预约日期',
        dataIndex: 'appointmentDate',
        width: 100,
        render: (t) => (t ? formatDayString(t) : '-')
      },
      {
        title: '时段',
        key: 'range',
        width: 80,
        render: (_, r) => this.formatTimeRange(r.startTime, r.endTime)
      },
      { title: '技师', dataIndex: 'technicianName', width: 80, render: (t) => renderTextStr(t) },
      {
        title: '是否已执行',
        dataIndex: 'isExecute',
        width: 80,
        render: (v) => (v ? <Tag color="success">已执行</Tag> : <Tag color="default">未执行</Tag>)
      },
      {
        title: '操作',
        key: 'op',
        width: 80,
        fixed: 'right',
        render: (_, r) => {
          if (r.isExecute) {
            return <span style={{ color: '#999' }}>—</span>
          }
          return (
            <Popconfirm title="确认取消该条预约？" onConfirm={() => this.handleCancelOne(r)}>
              <Button type="link" size="small" danger>
                取消
              </Button>
            </Popconfirm>
          )
        }
      }
    ]

    return (
      <Form ref={form} layout="vertical">
        <Spin spinning={loading}>
          {list.length === 0 && !loading ? (
            <Empty description="暂无预约安排" />
          ) : (
            <Table
              size="small"
              rowKey={(r) => String(r.id)}
              dataSource={list}
              columns={columns}
              pagination={false}
              scroll={{ x: 960 }}
            />
          )}
        </Spin>
      </Form>
    )
  }
}

export default CancelMemberProjectPlansForm
